var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "c-calendar__tooltip-day-marker" },
    _vm._l(_vm.numberOfDays, function (n) {
      return _c("span", {
        key: n,
        staticClass: "c-calendar__tooltip-day-marker-bar",
      })
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }